const Visualizar = () => import('@/domains/notas_fiscais/auxiliares/atividades_servicos/views/Visualizar')
const Listar = () => import('@/domains/notas_fiscais/auxiliares/atividades_servicos/views/Listar')
const Editar = () => import('@/domains/notas_fiscais/auxiliares/atividades_servicos/views/Editar')
const Adicionar = () => import('@/domains/notas_fiscais/auxiliares/atividades_servicos/views/Adicionar')

const routes = [
    {
        name: 'listarAtividadesServicosEmissor',
        path: '/emissor/atividades_servicos',
        alias: ['/emissor/atividades_servicos/index'],
        component: Listar
    },
    {
        name: 'visualizarAtividadeServicoEmissor',        
        path: '/emissor/atividades_servicos/visualizar/:id',
        component: Visualizar
    },
    {
        name: 'adicionarAtividadeServicoEmissor', 
        path: '/emissor/atividades_servicos/adicionar',
        component: Adicionar
    },
    {
        name: 'editarAtividadeServicoEmissor',      
        path: '/emissor/atividades_servicos/editar/:id',
        component: Editar
    },
]

export default routes
